import React, { ComponentType } from 'react'
import { IServerTableData } from '../../../types/tableTypes'
import { usePollingRowsManager } from '../../shared/lib/hooks/usePollingRowsManager'
import { OzonProductModel } from '../../../server/mpsklad_core/Models/OzonProductModel'
import { WbProductModel } from '../../../server/mpsklad_core/Models/WbProductModel'
import { YandexMarketProductModel } from '../../../server/mpsklad_core/Models/YandexMarketProductModel'
import { observer } from 'mobx-react-lite'
import { ProductCardPublicationStatus } from '../../../server/mpsklad_core/Models/MpCard/ProductCardPublicationStatus'

interface WithPollingOptions<TRow> {
  accountId: number

  reloadProduct: (id: string) => Promise<TRow | null>
}

export function withProductsPolling<
  TRow extends OzonProductModel | WbProductModel | YandexMarketProductModel,
  TColumnId extends string,
    TProps extends {products: IServerTableData<TRow, TColumnId>}
>(
    WrappedComponent: ComponentType<TProps>,
    options: WithPollingOptions<TRow>
  ): ComponentType<TProps> {
    return observer(function ComponentWithPolling(props: TProps) {
    const {products} = props
    const {reloadProduct} = options

    usePollingRowsManager<TRow>({
      rows: products.pageRows,
      pollingCondition: (row) => row.cardPublicationStatus === ProductCardPublicationStatus.Processing,
      getId: (row) => row.id,
      pollFunction: (id) => reloadProduct(String(id)),
      onUpdate: (updatedRow) => {
        const index = products.pageRows.findIndex(r => r.id === updatedRow.id)
        if (index >= 0) {
          products.pageRows[index] = updatedRow
        }
      },
      intervalMs: 10000
    })

    return <WrappedComponent {...props} />
  })
}
